export default import.meta.ROLLDOWN_FILE_URL_GwZi4FUDdk2Ax0TQ6Lw9Bg